import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useApi from "../../../core/customhook/useApi";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import Swal from "sweetalert2";
import { getFinancialYearList, getFinancialYearListNew } from "../../../core/common/financialYear";

const AllEmployeeGoalsProfile = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
   const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);

  const setEmployeeIDNAvigate = (ID: any) => {
    localStorage.setItem("GoalsProfileEmployeeID", ID);
    navigate(`/pms-employee-goals-profile/${ID}`);
  };

  const { data: teamData, loading: teamLoading } = useApi(
    "/api/manager/team-member-goal-profile",
    {
      method: "POST",
      payload: { finance_year: finance_year },
      autoCall: true,
      dependencies: [count, finance_year],
    },
  );

  const data = teamData?.data.map((item: any, index: any) => {
    return {
      ...item,
      Sno: index + 1,
    };
  });

  const {
    data: approveGoaldata,
    loading: approveLoading,
    error: approveError,
    callApi: ApproveGoalStatus,
  } = useApi("/api/manager/update-employee-category-status", {
    method: "POST",
    autoCall: false,
  });
  const approveGoal = async (
    employeeID: any,
    managerCareerAsprication: any,
  ) => {
    if (
      !managerCareerAsprication ||
      managerCareerAsprication === null ||
      managerCareerAsprication.trim() === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill the career aspiration information before approving",
      });
      return;
    }

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this goal profile?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
    });
    if (!confirmation.isConfirmed) return;
    const payload = {
      employee_id: employeeID,
      financial_year: finance_year,
      rejected_reason: null,
      status: "M Approved",
    };
    try {
      const response = await ApproveGoalStatus(payload);
      console.log(response);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message || "Goal profile approved successfully!",
          showConfirmButton: true,
        });
        setCount(count + 1);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while approving the goal.",
      });
    }
  };

  const {
    data: rejectGoaldata,
    loading: rejectLoading,
    error: rejectError,
    callApi: rejectGoalStatus,
  } = useApi("/api/manager/update-employee-category-status", {
    method: "POST",
    autoCall: false,
  });
  const rejectGoal = async (employeeID: any, categoryID: any) => {
    const { value: rejectedReason, isConfirmed } = await Swal.fire({
      title: "Reject Goal Profile",
      text: "Please provide a reason for rejection:",
      input: "textarea",
      inputPlaceholder: "Enter your reason here...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Rejection reason is required.";
        }
      },
    });

    if (!isConfirmed || !rejectedReason) return;

    const payload = {
      employee_id: employeeID,
      category_id: categoryID,
      financial_year: finance_year,
      rejected_reason: rejectedReason,
      status: "Rejected",
    };

    try {
      const response = await rejectGoalStatus(payload);
      console.log(response);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Rejected",
          text: response.message || "Goal profile rejected successfully!",
          showConfirmButton: true,
        });
        setCount(count + 1);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while rejecting the goal.",
      });
    }
  };

  const columns = [
    { title: "SNo.", dataIndex: "Sno" },
    {
      title: "EmpID",
      dataIndex: "employee_id",
      render: (text: string, record: any) => <p>{text}</p>,
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Name",
      dataIndex: "employee_name",
      render: (text: string, record: any) => <p>{text}</p>,
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Manager",
      dataIndex: "manager_name",
    },
    {
      title: "Goal Profile",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
          onClick={() => setEmployeeIDNAvigate(record.category_id)}
          title="View Goal Profile"
          disabled={record.category_id === null}
        >
          {record.category_id === null ? "N/A" : <i className="ti-eye" />}
        </button>
      ),
    },
    {
      title: "Action",
      render: (_: any, record: any) => {
        const isActionable = record.status === "E Submit";
        const isApproved = record.status === "M Approved";
        const isRejected = record.status === "Rejected";
        const isClosed = record.timingStatus === "Closed";

        const today = new Date().toISOString().split("T")[0];

        const isExpired = record.extended_manager_last_date < today;

        return (
          <div className="d-flex gap-2">
            {/* Approve Button */}
            <button
              className={`btn btn-sm ${
                isApproved || isRejected ? "btn-secondary" : "btn-success"
              } d-flex align-items-center justify-content-center`}
              onClick={() =>
                approveGoal(
                  record.employee_id,
                  record.manager_carrier_aspiration,
                )
              }
              title="Approve Goal"
              disabled={!isActionable || isExpired || isClosed}
            >
              {isApproved ? (
                <i className="ti-thumb-up" />
              ) : isActionable ? (
                <i className="ti-check" />
              ) : (
                <i className="ti-na" />
              )}
            </button>

            {/* Reject Button */}
            {isActionable && (
              <button
                className="btn btn-sm btn-warning d-flex align-items-center justify-content-center"
                onClick={() =>
                  rejectGoal(record.employee_id, record.category_id)
                }
                title="Reject Goal"
                disabled={isExpired || isClosed}
              >
                <i className="ti-close" />
              </button>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        let badgeClass = "bg-warning"; // default
        let displayText = text;

        if (text === "M Approved") {
          badgeClass = "bg-success";
          displayText = "Approved";
        } else if (text === "E Submit") {
          badgeClass = "bg-info";
          displayText = "Employee Submit";
        } else if (text === "Rejected") {
          badgeClass = "bg-danger";
          displayText = "Rejected";
        } else if (text === "In progress") {
          badgeClass = "bg-primary";
          displayText = "In progress";
        } else if (text === null) {
          badgeClass = "bg-secondary";
          displayText = "Not started";
        }

        return <span className={`badge ${badgeClass}`}>{displayText}</span>;
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div>
            <h2 className="mb-1">Employee Profile</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Dashboard</li>
                <li className="breadcrumb-item active">All Employee Profile</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex gap-2">
            <select
              value={finance_year}
              onChange={(e) => setFinance_year(e.target.value)}
              className="form-select"
            >
              {getFinancialYearListNew(finance_year).map((fy) => (
                <option key={fy} value={fy}>
                  {fy}
                </option>
              ))}
            </select>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h5>Employee List</h5>
          </div>
          <div className="card-body p-0">
            <Table
              dataSource={data || []}
              columns={columns}
              Selection={false}
              showSearchInput={true}
            />
          </div>
        </div>
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default AllEmployeeGoalsProfile;
